import Link from 'next/link';
import { Col, Divider, Grid, Row } from 'antd';
import ImageC from 'src/components/Image';
import { Title } from 'src/components/Layout/Typography';
import { IArticleByGroupDetail } from 'src/interface';
import AuthStorage from 'src/utils/auth-storage';
import { formatDate, getProfileListImage, googleArticleEvent } from 'src/utils/func';
import cn from "src/utils/cn";

type Props = {
	data: IArticleByGroupDetail[];
	length?: number;
	subCategory?: string;
	hideHeadingTitle?: boolean;
	showLabel?: boolean;
	headingLevel?: any;
	hideImage?: boolean;
};

const CardArticle = (props: Props) => {
	const breakpoint = Grid.useBreakpoint();
	const userAuth = AuthStorage.tokenDecode as any;

	const getArticleCat = (item: any) => {
		const getCat = item.cmp_article_category?.find((x: any) => x.is_primary)?.category;

		if (getCat) {
			return getCat;
		}

		return {
			full_slug: '',
			name: '-',
		};
	};

	const getArticleSlug = (index: number) => {
		const subCategory = props.subCategory;
		const slug = props.data[index]?.slug;
		const url = props.data[index]?.url;

		if (subCategory && !['latest', 'pilihan'].includes(subCategory)) {
			return `${subCategory?.startsWith('/') ? '' : '/'}${subCategory}/${slug}`;
		} else {
			return `/${props.data[index]?.type != 'general' ? props.data[index]?.type + '/' + url : url}`;
		}
	};

	const onClickArticle = (item: IArticleByGroupDetail) => {
		googleArticleEvent(item, userAuth, 'click');
	};

	return (
		<>
			{props.data?.length >= 1 &&
				props.data
					?.filter((card: any, index: any) => index != 0 || props.showLabel)
					.map((item: IArticleByGroupDetail, id: number) => (
						<div className="column-article" key={id}>
							<Row
								className="mb-0 sm:mb-5 min-h-25 sm:min-h-0 mt-3.5 lg:mt-5 xl:mt-7"
								gutter={breakpoint.xs ? [12, 8] : [24, 8]}
								wrap={false}
							>
								{!props.hideImage && (
									<Col>
										<div className="relative size-20 sm:size-26 lg:size-23.75">
											<ImageC
												className="rounded-[5px] object-cover"
												alt={item?.title}
												src={item?.media_images?.[1]?.thumb}
												fill
											/>
										</div>
									</Col>
								)}
								<Col>
									<div className="flex flex-col justify-between items-start">
										{props.showLabel && (
											<Link
												href={`${
													item.type != 'general' ? `/${item.type}` : ''
												}/${item.categories?.find((x: any) => x.is_current_category)?.full_slug}`}
												className="m-0 text-neutral-7 text-[11px] sm:text-[12px] leading-[19.2px] sm:leading-6"
											>
												<p className="m-0 font-semibold text-primary">
													{item.categories?.find((x: any) => x.is_current_category)?.name}
												</p>
											</Link>
										)}
										<a
											href={getArticleSlug(id + (props.showLabel ? 0 : 1))}
											onClick={() => onClickArticle(item)}
										>
											{props.hideHeadingTitle ? (
												<p
													className={cn(
														'font-semibold cursor-pointer text-neutral-3 hover:text-primary transition-colors',
														{
															'text-[14px] leading-[18.2px] w-[90%]': props.showLabel,
															'text-[14px] sm:text-[18px] leading-4.5 sm:leading-[25.2px]':
																!props.showLabel,
														},
													)}
												>
													{item.title}
												</p>
											) : (
												<h3
													className={cn(
														'font-semibold cursor-pointer text-neutral-3 hover:text-primary transition-colors',
														{
															'text-[14px] leading-[18.2px] w-[90%]': props.showLabel,
															'text-[14px] sm:text-[18px] leading-4.5 sm:leading-[25.2px]':
																!props.showLabel,
														},
													)}
												>{item.title}</h3>
											)}
										</a>
										{!props.showLabel && (
											<p className="m-0 text-neutral-7 text-[11px] sm:text-[14px] leading-[19.2px] sm:leading-6">
												<Link
													href={`/${getArticleCat(item).full_slug}`}
													className="mr-1.5 font-semibold text-primary hover:underline"
												>
													{getArticleCat(item).name}
												</Link>
												{formatDate(item.publish_date, 'DD MMM YYYY')}
											</p>
										)}
										{!breakpoint.xs && !props.showLabel && (
											<p className="text-neutral-5 line-clamp-3 text-[12px] sm:text-[14px] lg:text-[16px] leading-5.25 my-2">
												{item.short_desc}
											</p>
										)}
										{props.showLabel && (
											<p className="m-0 text-neutral-7 text-[11px] sm:text-[12px] leading-[19.2px] sm:leading-6">
												{formatDate(item.publish_date, 'DD MMM YYYY')}
											</p>
										)}
									</div>
								</Col>
							</Row>
							{breakpoint.xs && <Divider className="m-0 min-w-[90%] my-1! md:my-2!" />}
						</div>
					))}
		</>
	);
};

CardArticle.defaultProps = {
	showLabel: false,
};
export default CardArticle;
